import { useContext } from 'react';
import SectionContentGroupContext from '../../../../SectionContentGroupContext';
import ContentGroupType from '@/lib/constants/challengeModel/ContentGroupType.enum';
import { TextField, type TextFieldProps } from '@mui/material';
import { useIntl } from 'react-intl';
import EditorIsReadonlyContext from '@/pages/EditorPage/ChallengeModelsEditor/EditorIsReadonlyContext';

type EditorTextFieldProps = Omit<
  TextFieldProps,
  'variant' | 'placeholder' | 'fullWidth'
> & {
  placeholderId: string;
};

const EditorTextField = ({ placeholderId, ...props }: EditorTextFieldProps) => {
  const intl = useIntl();

  const currentSectionContentGroup = useContext(SectionContentGroupContext);
  const useFullWidth = currentSectionContentGroup === ContentGroupType.RIGHT;

  const editorIsReadonly = useContext(EditorIsReadonlyContext);

  return (
    <TextField
      variant="standard"
      placeholder={intl.formatMessage({
        id: placeholderId,
      })}
      fullWidth={useFullWidth}
      disabled={editorIsReadonly}
      {...props}
    />
  );
};

export default EditorTextField;
